export * from './Table';
export type {
  IFooterProps as ITableContainerFooterProps,
  IHeaderProps as ITableContainerHeaderProps,
} from './Table';
